export enum InboxMessageOrigin {
    MrworkInbox = 'mrwork_inbox',
    BirdFlow = 'bird_flow',
    ConversationalAgent = 'conversational_agent',
    JourneyAutomation = 'journey_automation',
}
